export default {
  data() {
    return {
      maxFrames: 100,
    };
  },

  methods: {

    getDataURL() {
      // console.log("Get URL:" + window.location.href);
      if (process.env.NODE_ENV == 'production')
        return process.env.VUE_APP_DATA_URL;

      return process.env.VUE_APP_DATA_URL;
    },

    getApiURL() {
      // console.log("Get URL:" + window.location.href);
      if (process.env.NODE_ENV == 'production')
        return process.env.VUE_APP_API_URL;

      return process.env.VUE_APP_API_URL_LOCAL;
    },

    getHomeURL() {
      // console.log("Get URL:" + window.location.href);
      if (process.env.NODE_ENV == 'production')
        return process.env.VUE_HOME_URL;

      return process.env.VUE_HOME_URL_LOCAL;
    },


    getReportURL() {
      console.log(process.env.VUE_APP_REPORT_URL);
      if (process.env.NODE_ENV == 'production')
        return process.env.VUE_APP_REPORT_URL;

      return process.env.VUE_APP_REPORT_URL;
    },


    getPHPURL() {
      console.log(process.env.VUE_APP_PHP_URL);
      if (process.env.NODE_ENV == 'production')
        return process.env.VUE_APP_PHP_URL;

      return process.env.VUE_APP_PHP_URL;
    },


    getMappaUrl() {

      if (process.env.NODE_ENV == 'production')
        return process.env.ICRON_VIRTUALDRONE_URL;

      return process.env.ICRON_VIRTUALDRONE_URL;

    },

    restCall(url) {
      const myHeaders = new Headers();
      //myHeaders.append('icron_token', global.helper.ls.get("IcronZero-Token"));
      // if (global.helper.ls.get("IcronZero-UserId") !== undefined) myHeaders.append('icron_user', global.helper.ls.get("IcronZero-UserId").toLowerCase());
      // myHeaders.append('icron_timer', global.helper.ls.get("IcronZero-Timer"));
      //myHeaders.append('icron_racefolder', global.helper.ls.get("IcronZero-RaceFolder"));
      //this.controlLoadingSpinner(true);
      //myHeaders.append('Access-Control-Allow-Origin', '*')
      return fetch(this.getApiURL() + url, {
        headers: myHeaders
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return response;
      })
    },

    getVideoData(idGara){
      let _url = this.getDataURL() + idGara+".csv?"+new Date();
      //console.log(_url);
      return fetch(_url).then((response) => {
        // this.controlLoadingSpinner(false);
        //console.log(response)
        return (response.text())
      })
    },

    

    getVideoLinks(idGara, divisione) {
      let _url = '/acquisti/getLavorazioniPubbliche';
      let _json = {
        "lavorazione": {
            "id_prodotto": idGara
        }
     };
      
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify(_json)
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },




    _csvJSON(csv){

      var lines=csv.split("\n");
    
      var result = [];
    
      // NOTE: If your columns contain commas in their values, you'll need
      // to deal with those before doing the next step 
      // (you might convert them to &&& or something, then covert them back later)
      // jsfiddle showing the issue https://jsfiddle.net/
      var headers=lines[0].split(",");
    
      for(var i=1;i<lines.length;i++){
    
          var obj = {};
          var currentline=lines[i].split(",");
    
          for(var j=0;j<headers.length;j++){
              obj[headers[j]] = currentline[j];
          }
    
          result.push(obj);
    
      }
    
      //return result; //JavaScript object
      return JSON.stringify(result); //JSON
    },


    getEventoIcron(idGara, divisione) {
      let _url = 'getIscrizioniLiveCheckin';
      let _json = {};
      _json.idGara = idGara;
      if (divisione && divisione !== 'none')
        _json.divisione = divisione;
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify(_json)
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },


    updateCustom(idGara, idList, field, value, token) {
      let _url = 'updateCampoCustom';
      let _json = {datiIscrizione: []};

      idList.forEach(element => {
        let _dato = {};
        _dato.idGara = idGara;
        _dato.id = element;
        _dato.criterio = field;
        _dato.campi_custom = value;
        _dato.token = token;
        _json.datiIscrizione.push(_dato);
      });
      
      this.controlLoadingSpinner(true);

      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify(_json)
      }).then((response) => {
        this.controlLoadingSpinner(false);
        return (response.json())
      })
    },



    saveAllegato(idGara, deskId, fileContent, tipoDoc, authToken, email, idIscrizione) {
      let _url = 'profilo/iscrizioni/uploadRicevutaIscrizione';

      let inputData = {
        "ricevuta": {
            "idiscrizione": idIscrizione,
            "idGara": idGara,
            "identificativo": idGara,
            "individuale": 1,
            "tipo": tipoDoc,
            "notedoc": 'Desk ' + deskId,
            "emailID": email,
            "content": fileContent,
            "UserId": email
        }
    }

    console.log("Save allegato:" + JSON.stringify(inputData));

    //reqConfig.headers['Content-Type'] = 'multipart/form-data'
    this.controlLoadingSpinner(true);
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        headers: { 
          'Authorization'  : `Bearer ${authToken}`,
          'Content-Type': 'application/json;charset=UTF-8',
          'Accept': 'application/json, text/plain, */*'
      },
        body: JSON.stringify(inputData)
      }).then((response) => {
        this.controlLoadingSpinner(false);
        return (response.json())
      })
    },

    getClassifica(jsonFile) {
      const myHeaders = new Headers();
      const _url = this.getReportURL() + jsonFile;
      //console.log(_url)
      return fetch(_url, {
        headers: myHeaders
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        //console.log(response)
        return (response.json())
      })
    },

    checkVersion(inout) {
      let _url = '/getVersion?appName=CAMON';
      return fetch(this.getApiURL() + _url, {
      }).then((response) => {
        return (response.json())
      })
    },

    getClassificaRR(idGara, token) {
      const myHeaders = new Headers();
      const _url = "https://api.raceresult.com/" + idGara + "/" + token;
      //console.log(_url)
      return fetch(_url, {
        headers: myHeaders
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        //console.log(response)
        return (response.json())
      })
    },


    getAttivitaGpsEvento(idGara, criterio) {
      let _url = '/gps/getProfiliAttivitaGps';
      let _json = { idGara: idGara }
      if (criterio !== undefined) {
        _json[criterio] = ""
      }
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify(_json)
        //body: "{}"
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },


    getSlotPrenotazioneEvento(idGara, data) {
      let _url = '/liquid/getOccupazioneSlot';
      let _json = { idGara: idGara }
      _json['data'] = data;
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify(_json)
        //body: "{}"
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },

    getGaraRandom(idGaraAri, token) {
      let _url = 'ari/getGaraAri/' + idGaraAri + '/' + token;
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify({ criterio: 'PART' })
        //body: "{}"
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },


    getPassaggiRandom(idGaraAri, token) {
      let _url = 'ari/elencoBrevetti/' + idGaraAri + '/' + token;
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify({ criterio: 'PART' })
        //body: "{}"
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },

    getAttivita(idAttivita, token) {
      let _url = 'gps/getAttivitaGps?idAttivita=' +
        idAttivita +
        '&token=' + token
      return this.restCall(_url)
        .then(result => {
          return (result.json())
        })
    },



    getConfiguration(idEvento) {
      let _url = 'events/' +
        idEvento +
        '/configuration.csv?d=' +
        new Date()
      return this.restCall(_url)
        .then(result => {
          return (result.text())
        })
    },

    getElencoDevices(idEvento) {
      let _url = 'events/' +
        idEvento +
        '/staff.csv?d=' +
        new Date()
      return this.restCall(_url)
        .then(result => {
          return (result.text())
        })
    },

    getElencoDevicesPartecipanti(idEvento) {
      let _url = 'events/' +
        idEvento +
        '/partecipanti.csv?d=' +
        new Date()
      return this.restCall(_url)
        .then(result => {
          return (result.text())
        })
    },

    getPercorso(idEvento, idPercorso, type) {
      if (type == undefined) type = "json";
      var suffix = "." + type;
      let _url = 'events/' +
        idEvento +
        '/' + idPercorso + suffix + '?d=' +
        new Date()
      console.log(_url)
      return this.restCall(_url)
        .then(result => {
          return (result.text())
        })
    },

    getAltimetria(idEvento, idPercorso) {
      var suffix = ".txt";
      let _url = 'events/' +
        idEvento +
        '/' + idPercorso + suffix + '?d=' +
        new Date()
      console.log(_url)
      return this.restCall(_url)
        .then(result => {
          return (result.text())
        })
    },


    csvJSON(csv) {
      var lines = csv.split("\n");
      var result = [];
      var headers = lines[0].split(";");
      for (var i = 0; i < headers.length; i++) {
        if (headers[i] != undefined)
          headers[i] = headers[i].replace(/[\s]+[,]+|[,]+[\s]+/g, ',').trim().toLowerCase();
      }
      for (var i = 1; i < lines.length; i++) {

        var obj = {};
        var currentline = lines[i].split(";");

        for (var j = 0; j < headers.length; j++) {
          obj[headers[j]] = currentline[j];
        }

        result.push(obj);

      }
      return result; //JSON
    },



    interpola(coordinates, indexGPS, currentFrame, maxFrames = 100) {
      if (indexGPS > 1) {
        var coordTmeno1 = coordinates[indexGPS - 1];
        let lonTmeno1 = coordTmeno1[0];
        let latTmeno1 = coordTmeno1[1];

        var currCoord = coordinates[indexGPS];
        let lonT = currCoord[0];
        let latT = currCoord[1];

        var newLon =
          lonTmeno1 + ((lonT - lonTmeno1) / maxFrames) * currentFrame;
        var newLat =
          latTmeno1 + ((latT - latTmeno1) / maxFrames) * currentFrame;

        // console.log(newLon + "-" + newLat)
        return [newLon, newLat];
      } else {
        return coordinates[indexGPS];
      }
    },


    dynamicSort(property) {
      return function (obj1, obj2) {
        return obj1[property] > obj2[property] ? 1
          : obj1[property] < obj2[property] ? -1 : 0;
      }
    },

    dynamicSortMultiple(self) {
      /*
       * save the arguments object as it will be overwritten
       * note that arguments object is an array-like object
       * consisting of the names of the properties to sort by
       */
      var props = arguments;
      return function (obj1, obj2) {
        var i = 0, result = 0, numberOfProperties = props.length - 1;
        /* try getting a different result from 0 (equal)
         * as long as we have extra properties to compare
         */
        while (result === 0 && i < numberOfProperties) {
          result = props[0].dynamicSort(props[i])(obj1, obj2);
          i++;
        }
        return result;
      }
    }


  }
}